module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/michigan-state-3905f048bc38c1639d91b8d74b35efac.svg";